import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { persistor, store } from "./store";

import App from "./App";

import "./styles/colors.scss";
import "./styles/fonts.scss";
import "./styles/global.scss";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

if ("serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker
			.register("/firebase-messaging-sw.js")
			.then((registration) => {
				console.log("Service Worker registered!");
			})
			.catch((err) => {
				console.log("Error registering Service Worker:", err);
			});
	});
}

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<HelmetProvider>
				<PersistGate loading={null} persistor={persistor}>
					<App />
				</PersistGate>
			</HelmetProvider>
		</Provider>
	</React.StrictMode>
);
